module.exports = __webpack_public_path__ + "img/Strip-Front-B9-Jc.b890f007.png";